import { createSelector } from 'reselect'

export const walletsSelector = (state) => state.wallet.wallets || {}

export const selectWallets = createSelector(
  [walletsSelector],
  (wallets) => {
    return wallets
  },
)
